<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>event_available</mat-icon> {{isEdit ? 'Einsatz bearbeiten' : 'Einsatz planen'}}
</h2>

<mat-dialog-content class="dialog-content">
  <div class="section-label"><mat-icon class="sk-inline-icon">groups</mat-icon> Wer arbeitet?</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Verantwortlich (z.B. Vorarbeiter)</mat-label>
    <mat-select [(ngModel)]="assignedUserId" required>
      <mat-option *ngFor="let u of data.users" [value]="u.id">{{userLabel(u)}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>person</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Weitere Beteiligte (Team)</mat-label>
    <mat-select [(ngModel)]="participantUserIds" multiple>
      <mat-option *ngFor="let u of data.users" [value]="u.id">{{userLabel(u)}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>groups</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width" *ngIf="(data.workers ?? []).length > 0">
    <mat-label>Arbeiter (ohne Login)</mat-label>
    <mat-select [(ngModel)]="workerIds" multiple>
      <mat-option *ngFor="let w of data.workers" [value]="w.id">{{w.name}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>construction</mat-icon>
  </mat-form-field>

  <div class="section-label"><mat-icon class="sk-inline-icon">schedule</mat-icon> Wann?</div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Datum</mat-label>
      <input matInput type="date" [(ngModel)]="startDate" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Von</mat-label>
      <input matInput type="time" [(ngModel)]="startTime" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Bis</mat-label>
      <input matInput type="time" [(ngModel)]="endTime" required>
    </mat-form-field>
  </div>

  <div class="sk-filter-chips preset-row">
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('07:00','16:00')"
            (click)="setTimes('07:00','16:00')">Ganztag 07–16</button>
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('07:00','12:00')"
            (click)="setTimes('07:00','12:00')">Vormittag 07–12</button>
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('12:00','17:00')"
            (click)="setTimes('12:00','17:00')">Nachmittag 12–17</button>
  </div>

  <div class="section-label"><mat-icon class="sk-inline-icon">location_on</mat-icon> Wo &amp; Details</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Titel</mat-label>
    <input matInput [(ngModel)]="title" [placeholder]="data.auftrag.title">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Einsatzort</mat-label>
    <input matInput [(ngModel)]="location">
    <mat-icon matPrefix>location_on</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Notizen</mat-label>
    <textarea matInput [(ngModel)]="notes" rows="2"></textarea>
  </mat-form-field>

  <div class="section-label"><mat-icon class="sk-inline-icon">handyman</mat-icon> Material (ohne Preise)</div>

  <!-- ===================================================== -->
  <!-- Gesperrt: alle Tagesberichte dieses Einsatzes sind     -->
  <!-- abgeschlossen. Keine Eingabemaske mehr, nur noch die   -->
  <!-- Liste des vorhandenen und geplanten Materials.         -->
  <!-- ===================================================== -->
  <ng-container *ngIf="materialGesperrt">
    <div class="plan-ro-row" *ngFor="let m of materialsAnzeige">
      <span class="plan-ro-name">{{ m.name }}</span>
      <span class="plan-ro-menge">{{ m.quantity }} {{ m.unit }}</span>
      <span class="plan-ro-art sk-muted">Freies Material</span>
    </div>

    <div class="plan-ro-row" *ngFor="let p of planLvPositionen">
      <span class="plan-ro-name">
        <strong>{{ p.nummer }}</strong> {{ planLvLabel(p) }}
      </span>
      <span class="plan-ro-menge">
        <ng-container *ngIf="p.planMenge !== null; else keinePlanmenge">
          Planmenge: {{ p.planMenge }} {{ p.einheit }}
        </ng-container>
        <ng-template #keinePlanmenge><span class="sk-muted">Planmenge offen</span></ng-template>
      </span>
      <span class="plan-ro-art sk-muted">LV-Position</span>
    </div>

    <p class="sk-muted plan-ro-empty" *ngIf="!hatGeplantesMaterial">
      Für diesen Einsatz wurde kein Material geplant.
    </p>

    <div class="plan-gesperrt">
      <mat-icon>lock</mat-icon>
      <span>{{ materialGesperrtHinweis }}</span>
    </div>
  </ng-container>

  <!-- Offen: Planung wie gewohnt bearbeitbar. -->
  <ng-container *ngIf="!materialGesperrt">

  <div class="material-row" *ngFor="let m of materials; let i = index">
    <mat-form-field appearance="outline" class="material-name">
      <mat-label>Material</mat-label>
      <input matInput [(ngModel)]="m.name" placeholder="z.B. Schalung">
    </mat-form-field>
    <mat-form-field appearance="outline" class="material-qty">
      <mat-label>Menge</mat-label>
      <input matInput type="number" min="0" step="0.5" [(ngModel)]="m.quantity">
    </mat-form-field>
    <mat-form-field appearance="outline" class="material-unit">
      <mat-label>Einheit</mat-label>
      <mat-select [(ngModel)]="m.unit">
        <mat-option value="Stk">Stk</mat-option>
        <mat-option value="m">m</mat-option>
        <mat-option value="m²">m²</mat-option>
        <mat-option value="m³">m³</mat-option>
        <mat-option value="kg">kg</mat-option>
        <mat-option value="t">t</mat-option>
        <mat-option value="l">l</mat-option>
        <mat-option value="Pal">Pal</mat-option>
        <mat-option value="Pkg">Pkg</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button (click)="removeMaterial(i)" matTooltip="Entfernen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="material-actions">
    <button mat-stroked-button class="add-material" (click)="addMaterial()">
      <mat-icon>add</mat-icon> Freies Material
    </button>

    <button mat-stroked-button class="add-material" *ngIf="isTakedaAuftrag"
            (click)="toggleLvPicker()">
      <mat-icon>{{ lvPickerOffen ? 'close' : 'add' }}</mat-icon> LV-Position
    </button>
  </div>

  <!-- LV-Auswahl: sucht im aktiven Leistungsverzeichnis des Kunden. -->
  <div class="lv-picker" *ngIf="isTakedaAuftrag && lvPickerOffen">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>LV-Position suchen (Nummer oder Bezeichnung)</mat-label>
      <input matInput [ngModel]="lvSearch" (ngModelChange)="onLvSearch($event)"
             placeholder="z.B. 01.02 oder Kabel">
      <mat-icon matPrefix>search</mat-icon>
      <mat-hint *ngIf="lvSearch.length > 0 && lvSearch.length < 2">
        Mindestens 2 Zeichen
      </mat-hint>
    </mat-form-field>

    <p class="sk-muted lv-hint" *ngIf="lvLoading">Suche läuft …</p>

    <div class="lv-treffer" *ngFor="let p of lvResults">
      <span class="lv-treffer-name">
        <strong>{{ p.nummer }}</strong>
        {{ p.bezeichnung || p.stichwort }}
        <span class="sk-muted" *ngIf="p.einheit">· {{ p.einheit }}</span>
      </span>
      <button mat-stroked-button type="button" (click)="addPlanLvPosition(p)">
        <mat-icon>add</mat-icon> Planen
      </button>
    </div>

    <p class="sk-muted lv-hint"
       *ngIf="!lvLoading && lvSearch.length >= 2 && lvResults.length === 0">
      Keine passenden LV-Positionen gefunden.
    </p>
  </div>

  <!-- Geplante LV-Positionen (SOLL). Planmenge ist optional. -->
  <ng-container *ngIf="isTakedaAuftrag && planLvPositionen.length > 0">
    <div class="section-label">
      <mat-icon class="sk-inline-icon">playlist_add_check</mat-icon> Geplantes LV-Material
    </div>

    <p class="sk-muted plan-hint">
      Planmengen sind nur eine Vorgabe – sie gelten noch nicht als verbraucht und
      sind nicht abrechnungswirksam. Im Tagesbericht lassen sie sich mit
      „Planmengen übernehmen“ in das tatsächliche Material übernehmen.
    </p>

    <div class="material-row plan-lv-row" *ngFor="let p of planLvPositionen; let i = index">
      <div class="plan-lv-name">
        <strong>{{ p.nummer }}</strong>
        <span class="plan-lv-text">{{ planLvLabel(p) }}</span>
      </div>

      <mat-form-field appearance="outline" class="plan-lv-menge">
        <mat-label>Planmenge</mat-label>
        <input matInput type="number" min="0" step="0.5" [(ngModel)]="p.planMenge"
               placeholder="offen">
      </mat-form-field>

      <!-- Die Einheit kommt aus dem LV-Schnappschuss und ist nicht bearbeitbar.
           Deshalb kompakte Anzeige statt Eingabefeld – und bewusst NICHT als
           matTextSuffix im Mengenfeld, wo sie unter das Label "Planmenge" läuft. -->
      <span class="plan-lv-einheit" [class.leer]="!p.einheit">{{ p.einheit || '–' }}</span>

      <button mat-icon-button class="plan-lv-entfernen" (click)="removePlanLvPosition(i)"
              matTooltip="Aus der Planung entfernen">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </ng-container>

  </ng-container>
  <!-- Ende: Planung bearbeitbar -->

  <!-- Bereits erfasstes Material dieses Einsatzes: readonly, alle Quellen.
       Unabhängig von der Sperre – es ist ohnehin nur Anzeige. -->
  <ng-container *ngIf="isTakedaAuftrag && isEdit">
    <div class="section-label" *ngIf="erfasstesMaterialLoading || erfasstesMaterial.length > 0">
      <mat-icon class="sk-inline-icon">fact_check</mat-icon> Bereits erfasst
    </div>

    <p class="sk-muted lv-hint" *ngIf="erfasstesMaterialLoading">
      Erfasstes Material wird geladen …
    </p>

    <div class="erfasst-row" *ngFor="let z of erfasstesMaterial">
      <span class="erfasst-name">
        <strong *ngIf="z.nummer">{{ z.nummer }}</strong>
        {{ z.bezeichnung }}
      </span>
      <span class="erfasst-menge">{{ z.menge }} {{ z.einheit }}</span>
      <span class="erfasst-herkunft sk-muted">{{ z.herkunft }}</span>
    </div>

    <p class="sk-muted lv-hint"
       *ngIf="!erfasstesMaterialLoading && erfasstesMaterial.length > 0">
      Diese Zeilen stammen aus dem Tagesbericht bzw. der Materialerfassung und werden
      dort gepflegt – hier nur zur Übersicht.
    </p>
  </ng-container>

  <mat-checkbox [(ngModel)]="sendInvite">
    Kalender-Einladung (Outlook/.ics) an die Beteiligten senden
  </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !valid">
    <mat-icon *ngIf="!saving">event_available</mat-icon>
    {{isEdit ? 'Speichern' : 'Einplanen'}}
  </button>
</mat-dialog-actions>
